<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-horizontal">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group row">
              <!-- <label class="col-form-label col-2"><span translate="MESTO.POSTBROJ.SINGULAR"></span></label> -->
              <div class="col-md-12">
                <yt-input
                  [Type]="'text'"
                  name="txtPosbr"
                  formControlName="PostBroj"
                  #focusElement
                  [MaxLength]="5"
                  [ngClass]="{'is-invalid': submitted && fc.PostBroj.invalid}"
                  [Label]="'MESTO.POSTBROJ.SINGULAR'">
                </yt-input>
                  <div class="form-error" *ngIf="submitted && fc.PostBroj.invalid">
                      <span *ngFor="let validation of errorMessages.PostBroj">
                        <span class="error-message" *ngIf="fc.PostBroj.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                  </div>              
                </div>
            </div>
          <div class="form-group row">
            <!-- <label class="col-form-label col-2"><span translate="MESTO.NAZIV.SINGULAR"></span></label> -->
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtNaziv"
                formControlName="Naziv"
                [MaxLength]="100"
                [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                [Label]="'MESTO.NAZIV.SINGULAR'">
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                    <span *ngFor="let validation of errorMessages.Naziv">
                      <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
            </div>
          </div>
          <div class="form-group row">
            <!-- <label class="col-form-label col-2"><span translate="MESTO.OPSTINAID.SINGULAR"></span></label> -->
            <div class="col-md-12">
                <!-- <yt-fw-dropdown
                [ModelName]="'opstina'"
                [GetName]="'get'"
                [ModelProperty]="'Naziv'"
                [OrderBy]="'Naziv'"
                [AllowAddNew]='true'
                [Disabled]='false'
                formControlName="OpstinaID"
                name="cmbOpstina"
                [Type]="ID"
                [ngClass]="{'is-invalid': submitted && fc.OpstinaID.invalid}"
                [Label]="'MESTO.OPSTINAID.SINGULAR'">
              </yt-fw-dropdown> -->
              <yt-dropdown-picklist
              [ModelName]="'opstina'"
              [GetName]="'get'"
              [ModelProperty]="'Naziv'"
              [OrderBy]="'Naziv'"
              [AllowAddNew]="true"
              [AllowEdit]="true"
              formControlName="OpstinaID"
              [Label]="'MESTO.OPSTINAID.SINGULAR'"
              >
        </yt-dropdown-picklist>
              <div class="form-error" *ngIf="submitted && fc.OpstinaID.invalid">
                  <span *ngFor="let validation of errorMessages.OpstinaID">
                    <span class="error-message" *ngIf="fc.OpstinaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
              </div>   
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>